/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Make_ConfidentialInputs */

const en_document_make_confidential = /** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make Confidential`)
};

const id_document_make_confidential = /** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadikan Rahasia`)
};

/** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */
const es_document_make_confidential = en_document_make_confidential;

/** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */
const fr_document_make_confidential = en_document_make_confidential;

/** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */
const de_document_make_confidential = en_document_make_confidential;

/** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */
const ja_document_make_confidential = en_document_make_confidential;

/** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */
const zh_document_make_confidential = en_document_make_confidential;

/** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */
const ar_document_make_confidential = en_document_make_confidential;

/** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */
const it_document_make_confidential = en_document_make_confidential;

/** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */
const ru_document_make_confidential = en_document_make_confidential;

/** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */
const pt_document_make_confidential = en_document_make_confidential;

/** @type {(inputs: Document_Make_ConfidentialInputs) => LocalizedString} */
const ko_document_make_confidential = en_document_make_confidential;

/**
* | output |
* | --- |
* | "Make Confidential" |
*
* @param {Document_Make_ConfidentialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_make_confidential = /** @type {((inputs?: Document_Make_ConfidentialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Make_ConfidentialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_make_confidential(inputs)
	if (locale === "es") return es_document_make_confidential(inputs)
	if (locale === "fr") return fr_document_make_confidential(inputs)
	if (locale === "de") return de_document_make_confidential(inputs)
	if (locale === "ja") return ja_document_make_confidential(inputs)
	if (locale === "zh") return zh_document_make_confidential(inputs)
	if (locale === "ar") return ar_document_make_confidential(inputs)
	if (locale === "id") return id_document_make_confidential(inputs)
	if (locale === "it") return it_document_make_confidential(inputs)
	if (locale === "ru") return ru_document_make_confidential(inputs)
	if (locale === "pt") return pt_document_make_confidential(inputs)
	return ko_document_make_confidential(inputs)
});